// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListTitle-displayFlex-TVbPL {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}

.ListTitle-padding-mvuB3 {
    padding: 42px 0px 27px;
}

.ListTitle-alignItemEnd-P3wbv {
    -webkit-box-align: end;
        -ms-flex-align: end;
            align-items: end;
}

.ListTitle-alignItemCenter-AWSTE {
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.ListTitle-lineHeight-_ZJjl {
    line-height: 20px;
}

.ListTitle-disGridTitle-kOIon{
    display: grid;
    grid-template-columns:  65% auto;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.ListTitle-textMinHeight-qTjTg{
    min-height: 39px;
}

@media screen and (max-width: 768px) {
    .ListTitle-disGridTitle-kOIon{
        grid-template-columns: 100%;
    }
    .ListTitle-justifyTab-rXYSZ{
        -webkit-box-pack: unset;
            -ms-flex-pack: unset;
                justify-content: unset;;
    }
}

@media screen and (max-width: 767px) {
    .ListTitle-mobilePadding-uRI9m {
        padding-bottom: 6px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/ListTitle/ListTitle.css"],"names":[],"mappings":"AAAA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,mBAAe;QAAf,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAgB;QAAhB,mBAAgB;YAAhB,gBAAgB;AACpB;;AAEA;IACI,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AACA;IACI,aAAa;IACb,gCAAgC;IAChC,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AACA;IACI,gBAAgB;AACpB;;AACA;IACI;QACI,2BAA2B;IAC/B;IACA;QACI,uBAAsB;YAAtB,oBAAsB;gBAAtB,sBAAsB;IAC1B;AACJ;;AACA;IACI;QACI,mBAAmB;IACvB;AACJ","sourcesContent":[".displayFlex {\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n}\n\n.padding {\n    padding: 42px 0px 27px;\n}\n\n.alignItemEnd {\n    align-items: end;\n}\n\n.alignItemCenter {\n    align-items: center;\n}\n\n.lineHeight {\n    line-height: 20px;\n}\n.disGridTitle{\n    display: grid;\n    grid-template-columns:  65% auto;\n    align-items: center;\n}\n.textMinHeight{\n    min-height: 39px;\n}\n@media screen and (max-width: 768px) {\n    .disGridTitle{\n        grid-template-columns: 100%;\n    }\n    .justifyTab{\n        justify-content: unset;;\n    }\n}\n@media screen and (max-width: 767px) {\n    .mobilePadding {\n        padding-bottom: 6px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"displayFlex": `ListTitle-displayFlex-TVbPL`,
	"padding": `ListTitle-padding-mvuB3`,
	"alignItemEnd": `ListTitle-alignItemEnd-P3wbv`,
	"alignItemCenter": `ListTitle-alignItemCenter-AWSTE`,
	"lineHeight": `ListTitle-lineHeight-_ZJjl`,
	"disGridTitle": `ListTitle-disGridTitle-kOIon`,
	"textMinHeight": `ListTitle-textMinHeight-qTjTg`,
	"justifyTab": `ListTitle-justifyTab-rXYSZ`,
	"mobilePadding": `ListTitle-mobilePadding-uRI9m`
};
module.exports = ___CSS_LOADER_EXPORT___;
